@let specialMenus = this.specialMenus();
@let activeMenu = this.activeMenu();

<app-page-header
  class="header"
  routerLink="/main/home"
  coreActivitySection="SpecialOffer"
  coreUserActivityClickTracking="CloseSpecialOffer"
/>

@if (!activeMenu && specialMenus && specialMenus.length > 1) {
  <div class="menus" coreActivitySection="SelectLanguage">
    @for (menu of specialMenus; track menu.id) {
      <button
        class="menus__name btn"
        (click)="this.activeMenu.set(menu)"
        [coreUserActivityClickTracking]="menu.name.split(' ').join('') + 'OpenSpecialOffer'"
      >
        {{ 'languages.' + menu.language + '.label' | translate }}
      </button>
    }
  </div>
}

@if (activeMenu) {
  <div class="menu" coreActivitySection="Menu">
    @for (url of activeMenu.pagesLocal; track url) {
      <core-menu-image [url]="url"/>
    }
  </div>
}
